import type { LazyInputBindsConfig } from 'vee-validate'

export const fieldConfig: LazyInputBindsConfig = state => ({
  props: {
    errorMessages: state.errors,
  },
})
